import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  GenerateOutreachMutation,
  GenerateOutreachMutationVariables,
} from "../../../generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const generateOutreach = graphql(`
  mutation generateOutreach($input: GenerateOutreachRequest!) {
    generateOutreach(GenerateOutreachRequest: $input) {
      responses {
        subject
        body
      }
    }
  }
`);

export function useGenerateOutreach(
  options?: UseMutationOptions<
    GenerateOutreachMutation,
    unknown,
    GenerateOutreachMutationVariables,
    unknown
  >,
) {
  return useGraphQlMutation(generateOutreach, options);
}
